// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__6AKf1","isActive":"Pagination_isActive__nCd4T","isSplit":"Pagination_isSplit__0DJ_Q","isText":"Pagination_isText__lnoc8"};